import React from 'react';
import RemoveModalTemplate from '@component/gridgio/modal/dialog-modal/remove-modal-template';
import { useTypedDispatch } from '@hook/common/useStore';
import { useRemoveProjectMutation } from '@hook/gridgio/useApi';
import { actions as modalActions } from '@store/slice/gridgio/modal-slice';
import type { IProjectRemoveModalData } from '@datatype/gridgio/type';

interface IProps {
  data: IProjectRemoveModalData['data'];
}

const ProjectRemoveModal: React.FC<IProps> = ({ data }) => {
  const dispatch = useTypedDispatch();
  const mutation = useRemoveProjectMutation();

  const handleCancel = () => {
    if (!mutation.isPending) dispatch(modalActions.hideModal());
  };
  const handleRemove = async () => {
    if (mutation.isPending) return;
    try {
      await mutation.mutateAsync(data.projectKey);
      dispatch(modalActions.hideModal());
    } catch {}
  };

  return (
    <RemoveModalTemplate
      title='프로젝트를 삭제할까요?'
      description='도면과 작업도 함께 삭제됩니다.'
      isPending={mutation.isPending}
      handleCancel={handleCancel}
      handleRemove={handleRemove}
    />
  );
};

export default ProjectRemoveModal;
